// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__bVmX_","row":"ProcedureTreatmentSummary_row__1r0nD"};